/**
 * Hook: is the current user a credit card approver?
 *
 * Approver = in `config.creditCardApproverEmails` OR a hub super-admin
 * (`hubRole` 'admin'/'super_admin') OR has the per-tool approver role
 * (`tools.creditCards.role` ∈ {'approver','approver_admin'}). Mirrors the
 * server-side `requireCreditCardApprover`. UI gating only — the callable
 * enforces auth.
 */

import { useProfile } from '../../profile/ProfileProvider';

export function useIsCreditCardApprover(): boolean {
  const { state } = useProfile();
  if (state.status !== 'ready') return false;
  const email = state.user.email.toLowerCase();
  if ((state.config.creditCardApproverEmails ?? []).map((e) => e.toLowerCase()).includes(email)) {
    return true;
  }
  if (state.user.hubRole === 'admin' || state.user.hubRole === 'super_admin') return true;
  const ccRole = state.user.tools?.creditCards?.role;
  return ccRole === 'approver' || ccRole === 'approver_admin';
}
